import React from "react";
import { IPropertyAnalyticsSummary } from "../types/ownerDashboard.types";
import { formatEngagementTime } from "../utils/formatEngagementTime";

interface PropertyAnalyticsSummaryProps {
  summary: IPropertyAnalyticsSummary;
}

const METRICS: {
  key: keyof IPropertyAnalyticsSummary;
  label: string;
  format: (value: number) => string;
}[] = [
  { key: "screen_page_views", label: "Visualizações", format: (value) => String(value) },
  { key: "active_users", label: "Usuários ativos", format: (value) => String(value) },
  {
    key: "screen_page_views_per_active_user",
    label: "Visualizações por usuário",
    format: (value) => value.toFixed(2),
  },
  {
    key: "average_engagement_time_seconds",
    label: "Tempo médio de engajamento",
    format: formatEngagementTime,
  },
  {
    key: "schedule_click_count",
    label: "Cliques em agendamento",
    format: (value) => String(value),
  },
  {
    key: "schedule_key_event_count",
    label: "Agendamentos concluídos",
    format: (value) => String(value),
  },
];

export default function PropertyAnalyticsSummary({ summary }: PropertyAnalyticsSummaryProps) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-6">
      {METRICS.map((metric) => (
        <div
          key={metric.key}
          className="rounded-2xl border border-white/[0.06] bg-white/[0.03] px-3 py-2.5"
        >
          <p className="text-[10px] font-semibold uppercase tracking-wide text-[#6e7681]">
            {metric.label}
          </p>
          <p className="mt-1 text-lg font-bold text-[#f0f6fc]">
            {metric.format(summary[metric.key])}
          </p>
        </div>
      ))}
    </div>
  );
}
